import Header from "./components/Header";
import Footer from "./components/Footer";
import Main from "./pages/Main";
import Details from "./pages/Details";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import Tracking from "./pages/Tracking";
import Admin from "./pages/Admin";
import Excel from "./pages/Excel";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./assets/style/index.css";
import { useSelector } from "react-redux";
import LoginAdmin from "./pages/LoginAdmin";
import DeleteAccount from "./pages/DeleteAccount";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import axios from 'axios';
import { useEffect, useState } from 'react';

const App = () => {
  const isAuth = useSelector((state) => state.isAuth);
  const [isAdmin, setIsAdmin] = useState(false);

  const myProfile = async () => {
    if (isAuth) {
      const { data } = await axios('https://ades.kg:8083/users/info', {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      });
      console.log("info",data)
      if (data.email === "admin") {
        setIsAdmin(true)
      }
    }
  }

  useEffect(() => {
    myProfile()
  }, [])

  return (
    <>
      <Router>
        <Header />
        <Routes>
          <Route element={<Main />} path="/" />
          <Route element={<Details />} path="/details" />
          <Route element={<Login />} path="/login" />
          <Route element={<Registration />} path="/registration" />
          <Route element={<LoginAdmin />} path="/admin" />
          <Route element={<Tracking />} path="/tracking" />
          <Route element={<DeleteAccount />} path="/delete-account" />
          <Route element={<PrivacyPolicy />} path="/privacy-policy" />
          <Route element={<Support />} path="/support" />
          {isAuth && (
            <>
              <Route element={<Profile />} path="/profile" />
              {
                isAdmin && (
                  <>
                    <Route element={<Admin />} path="/adminpage" />
                    <Route element={<Excel />} path="/excel/:store/:type/" />
                  </>
                )
              }
            </>
          )}
        </Routes>
      </Router>

      <Footer />
    </>
  );
};

export default App;
